import React, {useCallback} from 'react';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {MaterialReactTable, useMaterialReactTable} from 'material-react-table';
//
import {BALANCES_REPORT_COLUMN_DEFS} from 'utils/tables/columns/reports/balances';

const StyledTableContainer = styled(Box)(() => ({
    width: '100%',
    ['& tbody .MuiTableCell-body']: {
        whiteSpace: 'nowrap',
    },
}));

const ReportTable = ({paginationModel, sorting, onSortingChange, onPaginationChange, ...props}) => {

    const renderCustomActions = useCallback(()=>
        (
          <Box
            display='flex' gap='1rem' p='0.5rem' flexWrap='wrap'
          >
            <div className='actions_cover active' style={{padding: 0}}>
              <div className='actions_cover-item' onClick={props.onDownload}>
                <FileDownloadIcon style={{marginBottom: '-7px'}} />
                <span>Export data</span>
              </div>
            </div>
          </Box>
        ), [props.onDownload]);

    const table = useMaterialReactTable({
        columns: BALANCES_REPORT_COLUMN_DEFS,
        data: props.rowData,
        rowCount: props.count,
        enableRowSelection: true,
        enableColumnResizing: true,
        enableFilters: false,
        columnFilterDisplayMode: 'popover',
        positionToolbarAlertBanner: 'bottom',
        enableSortingRemoval: false,
        manualPagination: true,
        manualSorting: true,
        onSortingChange: onSortingChange,
        onPaginationChange: onPaginationChange,
        meta: {
            totals: props.totals,
        },
        muiPaginationProps: {
            rowsPerPageOptions: [100, 500, 1000, 5000],
        },
        state: {
            isLoading: props.isRequestPending,
            pagination: paginationModel,
            sorting,
        },
        renderTopToolbarCustomActions: renderCustomActions,
    });

    return (
      <StyledTableContainer>
        <MaterialReactTable table={table} />
      </StyledTableContainer>
    );
};

export default ReportTable;
